import { Injectable } from '@angular/core';

import { AuthService } from 'common/src/auth/auth.service';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class FileDownloadUrlService {

  constructor(private readonly authService: AuthService) { }

  public getUrl(file: { title: string; key: string }): string {
    const basicPath = environment.javaApiUrl + environment.javaApiVersion;
    const apiPath = '/utils/download';
    const params = {
      name: encodeURIComponent(file.title),
      resource: file.key,
      uid: this.authService.getToken()
    };
    return `${basicPath}${apiPath}?${new URLSearchParams(params).toString()}`;
  }

  public getType(file: { title: string }): 'pdf' | 'image' {
    return file.title && file.title.toLowerCase().endsWith('.pdf') ? 'pdf' : 'image';
  }
}
